import { Blog } from "@custom-types/BlogModel";

export const SET_BLOGS = "SET_BLOGS";

export const setBlogs = (blogs: Array<Blog>, paginator: { page: number; totalDocs: number; totalPages: number }) => {
    return { type: SET_BLOGS, blogs, paginator };
};
